import { generateUniqueId } from '../../helpers/common';

export const LOGIN_REQUEST = generateUniqueId();
export const LOGIN_SUCCESS = generateUniqueId();
export const LOGIN_FAILURE = generateUniqueId();
export const SHOW_INCORRECT_CREDENTIAL_MSG = generateUniqueId();
export const SET_USER_ID_CHECKING_INTERVAL_ID = generateUniqueId();

export const REFRESH_TOKEN_SUCCESS = generateUniqueId();
export const REFRESH_TOKEN_FAILURE = generateUniqueId();

export const LOAD_USER_DATA_REQUEST = generateUniqueId();
export const LOAD_USER_DATA_SUCCESS = generateUniqueId();
export const LOAD_USER_DATA_FAILURE = generateUniqueId();

export const LOGOUT_REQUEST = generateUniqueId();

export const SEND_OPT_REQUEST = generateUniqueId();
export const SEND_OPT_SUCCESS = generateUniqueId();
export const SEND_OPT_FAILURE = generateUniqueId();

export const RESET_PASSWORD_REQUEST = generateUniqueId();
export const RESET_PASSWORD_SUCCESS = generateUniqueId();
export const RESET_PASSWORD_FAILURE = generateUniqueId();

export const LOAD_USER_UI_ACCESS = generateUniqueId();

export const LOAD_GRAPH_COLORS_SUCCESS = generateUniqueId();

export const USER_DATA_MQTT = generateUniqueId();